// bao migrate skip
import ConfigurationItemAuditDialog from "./../../factories/configuration-item-audit-dialog";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import * as $ from "jquery";
import BaoDialog from "./../../factories/bao-dialog";
import finitoService from "./../../services/finito-service";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import TagTabHistoryViewModel from "./../tag-tab-history";
class ShiftReportTagTab extends SubscriptionViewModel {
    enableButton: (actionpKey: string, enabled: boolean) => void;
    OriginalVersionDate: KnockoutObservable<any>;
    constructor(tabPage, shiftReportViewModel) {
        super(tabPage);
        this.ShiftReport = shiftReportViewModel;
        (<any>this.TabPage).TabSelected = () => {
            this.CalculateWidth();
        };
        //
        // Subscribe auf Berichtabschluss 
        this.subscribe(this.ShiftReport.IsClosed, (isClosed) => {
            this.toggleButtons();
        });
        this.subscribe(this.ShiftReport.IsOriginal, (isOriginal) => {
            if (isOriginal && !this.RevisionStateUpdating) {
                return this.UpdateTab(ko.unwrap(this.OriginalVersionDate)).then(() => {
                    this.TabPage.IsLoading(false);
                });
            }
        });
        this.subscribe(this.ShiftReport.CurrentRevision, (currentRevision) => {
            if (currentRevision && !this.RevisionStateUpdating) {
                this.RefreshTab();
            }
        });
        this.subscribe(this.ShiftReport.IsShiftClosure, (isShiftClosure) => {
            if (isShiftClosure && !this.RevisionStateUpdating) {
                return this.UpdateTab(ko.unwrap(this.OriginalVersionDate)).then(() => {
                    this.TabPage.IsLoading(false);
                });
            }
        });
        this.TabPage.DirtyFlag.subscribe((isDirty) => {
            //TODO: Parent Methode zum Dirty Check der Childtabs aufrufen (für * im Haupttab)
        });
    }
    AuditTrail(): any {
        let getCollectionUrl = "TagTab/GetAuditTrail";
        let filterArea = null;
        if (ko.unwrap(this.AreaFilterSelectedItem())) {
            filterArea = ko.unwrap(this.AreaFilterSelectedItem().Key);
        }
        // hack: set id to an object
        let filterId = { "ReportId": ko.unwrap(this.ShiftReport.ReportId), "FilteredAreaId": filterArea };
        let auditDialog = new ConfigurationItemAuditDialog(filterId as any, ko.unwrap(this.TabPage.Title), this.TabPage, getCollectionUrl);
        auditDialog.Open();
    }
    _AreaFilterItems = ko.observableArray([]);
    /**
     *
     */
    AreaFilterItems = ko.pureComputed({
        read: () => {
            return this._AreaFilterItems();
        },
        write: (value: {
            IsSelected: KnockoutObservable<boolean>;
            Value: string;
        }[]) => {
            if (value && value.length) {
                let selectedItemExists = false;
                // setze standardwert IsSelected = false
                for (let i in value) {
                    if (typeof value[i].IsSelected !== "undefined") {
                        value[i].IsSelected = ko.observable(ko.unwrap(value[i].IsSelected) == true);
                        if (value[i].IsSelected() === true) {
                            selectedItemExists = true;
                        }
                    }
                    else {
                        value[i].IsSelected = ko.observable(false);
                    }
                }
                // alphabetisch sortieren
                value.sort((a, b) => {
                    let aComp = a.Value.toUpperCase();
                    let bComp = b.Value.toUpperCase();
                    if (aComp < bComp) {
                        return -1;
                    }
                    if (aComp > bComp) {
                        return 1;
                    }
                    return 0;
                });
                // setze ersten auf Selected, falls keiner selected ist
                if (selectedItemExists === false) {
                    value[0].IsSelected(true);
                }
                this._AreaFilterItems(value);
            }
            else {
                this._AreaFilterItems([]);
            }
        },
        owner: self
    });
    AreaFilterSelectedItem = ko.pureComputed(() => {
        let items = this.AreaFilterItems();
        for (let i in items) {
            if (items[i].IsSelected()) {
                return items[i];
            }
        }
    });
    AreaFilterSelectedItemDelayed = ko.pureComputed(this.AreaFilterSelectedItem)
        .extend({ rateLimit: { mehtod: "notifyWhenChangesStop", timeout: 400 } });
    /**
     * Event: badge item selected - Only singleSelect - no deselect
     * @param item object the selected item or null when deselct
     */
    badgeItemSelected = (item) => {
        let oldState = item.IsSelected();
        // prevent deselect
        if (oldState === true) {
            return;
        }
        // deselect all Items
        let items = this.AreaFilterItems();
        for (let i in items) {
            items[i].IsSelected(false);
        }
        // Select Item if oldState was unselect
        if (oldState === false) {
            item.IsSelected(!item.IsSelected());
        }
    };
    /**
     * Event: badge item removed
     */
    badeItemsRemove = (item) => {
        // check if deletedIem is selected
        let deleteItemIsSelected = item.IsSelected() === true;
        this._AreaFilterItems.remove(item);
        // setze selected auf neues item, wenn sonst keiner mehr selected wäre und noch items exisiteren.
        if (deleteItemIsSelected && this._AreaFilterItems().length > 0) {
            this._AreaFilterItems()[0].IsSelected(true);
        }
    };
    /**
     * Event: badge item removed
     */
    badeItemsRemoveAll = () => {
        this._AreaFilterItems.removeAll();
    };
    GetCustomAreaFilterFilter = ko.pureComputed(() => {
        return {
            OnlyAreasWithTagsInReportId: this.ShiftReport.ReportId()
        };
    });
    AreaFilterBaoSearcherOptions = {
        ObjectId: ko.observable(null),
        SearchType: "Area",
        ObjectValue: "ShortName",
        MultiSelect: true,
        AutoComplete: true,
        Items: this.AreaFilterItems,
        CustomFilter: this.GetCustomAreaFilterFilter // << TODO: OrgUnit
    }; //: baoSearcher
    // Container für die Funktion zum Öffnen des SearchDialogs
    // wird vom binding implementiert
    OpenAreaFilterSearchDialog = () => { };
    CalculateWidth = () => {
        //Dummy
    };
    BaoRouterSubscriptions = [];
    Bao = Bao;
    ShiftReport: {
        ReportId: KnockoutObservable<string>;
        IsClosed: KnockoutObservable<boolean>;
        IsOriginal: KnockoutObservable<boolean>;
        CurrentRevision: KnockoutObservable<string>;
        IsShiftClosure: KnockoutObservable<boolean>;
        toggleOriginal: (state: boolean) => void;
        toggleRevision: (state: boolean) => void;
    } = null;
    TabName = ko.observable();
    TemplateName = ko.observable();
    TemplateContext = ko.observable();
    IsHistory = ko.observable(false);
    HasHistory = ko.observable(false);
    ToolbarButtons = ko.observableArray();
    SaveAllowed = ko.observable();
    ImportAllowed = ko.observable();
    TagList = ko.observableArray<{
        IsWriteTag: KnockoutObservable<boolean>;
        TagId: KnockoutObservable<string>;
    }>();
    /**
     * Die Tags, welche IsWrite == true sind. Also die ExportTags
     */
    TagListExport = ko.pureComputed(() => {
        let tagList = this.TagList();
        let returnList = [];
        for (let i in tagList) {
            if (ko.unwrap(tagList[i].IsWriteTag) == true) {
                returnList.push(tagList[i]);
            }
        }
        return returnList;
    });
    /**
     * Die Tags, welche IsWrite == false sind. Also die ImportTags
     */
    TagListImport = ko.pureComputed(() => {
        let tagList = this.TagList();
        let returnList = [];
        for (let i in tagList) {
            if (ko.unwrap(tagList[i].IsWriteTag) == false) {
                returnList.push(tagList[i]);
            }
        }
        return returnList;
    });
    TagValues = ko.observableArray([]);
    RevisionStateUpdating = false;
    ToolbarLoaded = () => {
        this.toggleButtons();
    };
    toggleButtons() {
        if (this.enableButton != undefined) {
            let canSave = Boolean(!this.IsHistory() && this.SaveAllowed());
            let taglist = ko.unwrap(this.TagListImport);
            let canImport = Boolean(!this.IsHistory() && this.ImportAllowed() && taglist?.length > 0);
            this.enableButton('ShiftReportTabTagImport', canImport);
            this.enableButton('ShiftReportTabTagSave', canSave);
            this.enableButton('ShiftReportTabTagHistory', this.HasHistory());
        }
    }
    ;
    /**
     * get tag values from provider
     */
    ImportTagValues() {
        this.TabPage.IsLoading(true);
        let taglist = ko.unwrap(this.TagListImport);
        if (!taglist || taglist.length === 0) {
            return;
        }
        let TagIds = [];
        for (let i in taglist) {
            TagIds.push(ko.unwrap(taglist[i].TagId));
        }
        return Bao.post("TagValues/ImportFromProvider", JSON.stringify({ tagIds: TagIds, reportId: this.ShiftReport.ReportId() }))
            .done((data) => {
                if (data !== null) {
                    for (let i in data) {
                        this.SetTagValueByTagId(data[i].TagId, data[i].NumericValue, data[i].BooleanValue, data[i].TextValue, data[i].TagValueHtml);
                    }
                }
                this.TabPage.IsLoading(false);
            });
    }
    ;
    /**
     * export tag values to provider
     */
    ExportTagValues() {
        this.TabPage.IsLoading(true);
        let taglist = ko.unwrap(this.TagListExport);
        if (typeof taglist === "undefined" || taglist === null) {
            return;
        }
        let TagIds = [];
        for (let i in taglist) {
            TagIds.push(ko.unwrap(taglist[i].TagId));
        }
        return Bao.post("TagValues/ExportUniversalFieldsToProvider", JSON.stringify({ tagIds: TagIds, tagValues: ko.map.toJS(this.TagValues()), reportId: this.ShiftReport.ReportId() }))
            .then((data) => {
                if (data !== null) {
                    for (let i in data) {
                        this.SetTagValueByTagId(data[i].TagId, data[i].NumericValue, data[i].BooleanValue, data[i].TextValue, data[i].TagValueHtml);
                    }
                }
                this.TabPage.IsLoading(false);
            });
    }
    ;
    SetTagValueByTagId(tagId, numericValue, booleanValue, textValue, valueHtml) {
        let tagvallist = ko.unwrap(this.TagValues);
        if (tagvallist === null) {
            return;
        }
        for (let i in tagvallist) {
            if (ko.unwrap(tagvallist[i].TagId) === tagId) {
                tagvallist[i].NumericValue(numericValue);
                tagvallist[i].BooleanValue(booleanValue);
                tagvallist[i].TextValue(textValue);
                tagvallist[i].TagValueHtml(valueHtml);
                this.TagValues(tagvallist);
                return;
            }
        }
    }
    ;
    StringIsNullOrEmpty(string) {
        // solange die funktion noch nicht voll funktionstüchtig ist(#108283)
        //return Bao.Utils.String.IsNullOrEmpty(string);
        // nutze eigene Implementierung
        if (string === null)
            return true;
        else if (string === "")
            return true;
    }
    ;
    /**
     *
     * @returns jQueryPromise<bool>
     */
    CompleteCheck(closeReport) {
        // Pflichtfelder sind nur beim schließen eines berichtes relevant
        if (closeReport != true) {
            return $.Deferred().resolve(true).promise();
        }
        return this.CheckChangesToSave().then((goOn: boolean) => {
            if (goOn) {
                return Bao.post("TagTab/CompleteCheckForReportClose", JSON.stringify({ reportId: this.ShiftReport.ReportId(), shiftbookTabId: null }));
            }
            return $.Deferred().resolve(false).promise();
        });
    }
    /**
     * return true if no changes made, saveallowed is false or is history
     */
    canClose(): JQueryPromise<boolean> | boolean {
        if (this.IsHistory() || this.SaveAllowed() == false) {
            return true;
        }
        else if (this.TabPage.DirtyFlag()) {
            return false;
        }
        else {
            return true;
        }
    }
    CloseReport() {
        return this.Close();
    }
    ToolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "ShiftReportTabTagSave":
                this.ExportTagValues()
                    .then(() => {
                        this.Save();
                    });
                break;
            case "ShiftReportTabTagImport":
                //Check if the report has been closed
                if (this.ShiftReport.IsClosed()) {
                    var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage('AddEventToClosedReport'), "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            this.ImportTagValues();
                        }
                    }.bind(this));
                }
                else {
                    this.ImportTagValues();
                }
                break;
            case "ShiftReportTabTagHistory":
                // old
                //this.showHistory();
                // new
                this.AuditTrail();
                break;
            default:
                break;
        }
    };
    // save this form - no need to check mandatory fields - the parent invokes CompleteCheck when closing report.
    Save() {
        this.TabPage.IsLoading(true);
        return Bao.post("TagTab/Save", JSON.stringify({ tagValues: ko.map.toJS(this.TagValues()), reportId: this.ShiftReport.ReportId() }), (result) => {
            if (result) {
                this.showAlert(finitoService.MessageKeys.SaveSuccessful);
            }
            else {
                this.showAlert(finitoService.MessageKeys.SaveError);
            }
            this.TabPage.DirtyFlag(false);
            return this.UpdateValues().then(() => {
                this.TabPage.IsLoading(false);
            });
        });
    }
    Close() {
        this.TabPage.IsLoading(true);
        let def = $.Deferred();
        this.TabPage.DirtyFlag(false);
        this.UpdateValues().then(() => {
            this.TabPage.IsLoading(false);
            def.resolve();
        });
        return def.promise();
    }
    // aktualisiert den Tab/TagList
    RefreshTab() {
        this.TabPage.IsLoading(true);
        let version;
        if (this.ShiftReport.IsOriginal() || this.ShiftReport.IsShiftClosure()) {
            version = this.OriginalVersionDate();
        }
        return $.when(this.canClose())
            .then((canClose) => {
                if (canClose) {
                    return this.UpdateTab(version);
                }
                return this.CheckChangesToSave(canClose)
                    .then((savedOrDiscarded) => {
                        return this.UpdateTab(version);
                    });
            })
            .then(() => {
                this.TabPage.DirtyFlag(false);
                this.TabPage.IsLoading(false);
            });
    }
    /**
     * Lädt die Area-Items, welche zuletzt gespeichert wurden
     */
    LoadLastAreaFilterItems() {
        return Bao.post("TagTab/GetLastAreaFilterItems", JSON.stringify({ reportId: this.ShiftReport.ReportId() }))
            .then((data) => {
                this.AreaFilterItems(data.models);
            });
    }
    /**
     * Speichert die aktuellen Area-Items
     */
    SaveLastAreaFilterItems() {
        return Bao.post("TagTab/SetLastAreaFilterItems", JSON.stringify({ reportId: this.ShiftReport.ReportId(), settings: this.AreaFilterItems() }))
            .then((data) => {
            });
    }
    init() {
        this.TabPage.IsLoading(true);
        // get area-Filter-Objects
        return this.LoadLastAreaFilterItems()
            // and then tags
            .then(() => {
                // if original-version is needed
                if (this.ShiftReport.IsOriginal()) {
                    // need to get the version to use existing code
                    return Bao.post("TagTab/GetOriginalVersion", JSON.stringify({ reportId: this.ShiftReport.ReportId() }))
                        .then((version) => {
                            return this.UpdateTab(version);
                        });
                }
                // load latest version
                return this.UpdateTab(null);
            })
            // alle daten geladen, set subscribes
            .then(() => {
                this.AreaFilterSelectedItemDelayed.subscribe(() => {
                    this.RefreshTab();
                });
                this.AreaFilterItems.subscribe(() => {
                    this.SaveLastAreaFilterItems();
                });
                this.TabPage.IsLoading(false);
            });
    }
    loaded() {
        this.TabPage.IsLoading(false);
    }
    showHistory() {
        let self = this;
        Bao.get('TagTab/History', $.param({
            id: (<any>this.TabPage).FormHistoryId,
            reportId: this.ShiftReport.ReportId()
        })).then((html) => {
            let dialog = new BaoDialog(Bao.Session.GetMessage('msgHistory'));
            dialog.ViewModel(new TagTabHistoryViewModel(this.ShiftReport.ReportId(), (historyItem) => {
                this.UpdateTab(historyItem.Version(), historyItem.IsNewestRevision());
                dialog.Close();
            }));
            dialog.Template(html);
            dialog.Width("300");
            dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => {
                        if (dialog.ViewModel().Selection()) {
                            let historyItem = dialog.ViewModel().Selection()[0];
                            if (historyItem) {
                                this.UpdateTab(historyItem.Version(), historyItem.IsNewestRevision());
                            }
                        }
                        dialog.Close();
                    },
                    Enabled: dialog.ViewModel().HasSelection,
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                },
                {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: () => {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                }
            ]);
            dialog.ViewModel().initialize();
            dialog.Open();
        });
    }
    /**
     * Updates template and values - discards changes
     * @param version
     * @param IsNewestRevision
     */
    UpdateTab(version?, IsNewestRevision?) {
        let self = this;
        let def = $.Deferred();
        if (IsNewestRevision === true) {
            version = null;
        }
        this.TemplateName(null);
        this.TemplateContext(null);
        let filterArea = null;
        if (ko.unwrap(this.AreaFilterSelectedItem())) {
            filterArea = ko.unwrap(this.AreaFilterSelectedItem().Key);
        }
        Bao.post("TagTab/Template", JSON.stringify({
            reportId: this.ShiftReport.ReportId(),
            version: version,
            filterAreaId: filterArea
        }), (result) => {
            let htmlUrl = "TagTabTemplate_" + this.ShiftReport.ReportId();
            if (version) {
                htmlUrl = htmlUrl + "_" + version;
            }
            this.TagList(result.model);
            this.UpdateValuesResult(result.tagTabModel, version);
            Bao.Templates[htmlUrl] = result.html;
            this.TemplateName(htmlUrl);
            def.resolve();
        });
        return def.promise();
    }
    /**
     * check if this could be closed
     * check if there are unsaved changes and ask if these should be saved, discard or cancle the action
     * returns true if changes are saved or changes are discarded - returns false if the user wants to cancel the action
     */
    CheckChangesToSave(canClose: JQueryPromise<boolean> | boolean = this.canClose()): JQueryPromise<boolean> {
        return $.when(canClose)
            .then((canCloseRes) => {
                if (canCloseRes !== false) {
                    return true;
                }
                return this.shouldSave()
                    .then((shouldSave) => {
                        if (shouldSave) {
                            return this.Save()
                                .then(() => {
                                    return true;
                                });
                        }
                        else if (shouldSave === false) {
                            return true;
                        }
                        // neither true nor else = cancel = (undefined or null)
                        return false;
                    });
            });
    }
    shouldSave = (fn?) => {
        let deferred = $.Deferred();
        let isLoading = this.TabPage.IsLoading();
        this.TabPage.IsLoading(false);
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUniversalfelderSave"), 'yesno');
        dialog.DialogResult.subscribe((shouldSave) => {
            this.TabPage.IsLoading(isLoading);
            deferred.resolve(shouldSave);
        });
        return deferred.promise();
    }
    GetFilteredAreaId() {
        let filterAreaId = null;
        if (ko.unwrap(this.AreaFilterSelectedItem())) {
            filterAreaId = ko.unwrap(this.AreaFilterSelectedItem().Key);
        }
        return filterAreaId;
    }
    UpdateValues(version?) {
        let self = this;
        return Bao.post("TagTab/GetValues", JSON.stringify({
            reportId: this.ShiftReport.ReportId(),
            version: version,
            filterAreaId: this.GetFilteredAreaId()
        }), (model) => {
            this.UpdateValuesResult(model, version);
        });
    }
    private UpdateValuesResult(tabTabModel, version) {
        ko.map.fromJS(tabTabModel, this, this.TabPage.DirtyFlag);
        this.toggleButtons();
        this.setTabTitle();
        this.TemplateContext(this);
    }
    getTagObservable(tagId) {
        let obs = null;
        ko.utils.arrayForEach(this.TagValues(), (item) => {
            if (ko.unwrap(item.TagId) == tagId) {
                obs = item;
            }
        });
        return obs;
    }
    getTagModel(tagId) {
        let obs = null;
        ko.utils.arrayForEach(this.TagList(), (item) => {
            if (ko.unwrap(item.TagId) == tagId) {
                obs = item;
            }
        });
        return obs;
    }
    setTabTitle() {
        let self = this;
        //this.TabPage.Title(this.TabName());
    }
    pauseDirtyFlag() {
        this.TabPage.DirtyFlag.pause();
    }
    resumeDirtyFlag() {
        this.TabPage.DirtyFlag.resume();
    }
}
export default ShiftReportTagTab;